module.exports = __webpack_public_path__ + "img/test.272e7e84.svg";